<template>
  <div id="shopping-cart">
    <div class="sectionHeader" v-if="showHeader">
      <div class="isFixed">
        <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
      </div>
    </div>
    <!--    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>-->
    <div class="wrapper">
      <div class="empty-row" v-show="cartList.length<=0">
        <div class="image"></div>
        <div class="tip">购物车中还没有产品，赶快去选购吧！</div>
        <div class="buy" @click="goToGoods">去购物</div>
      </div>

      <div class="c-section" v-show="cartList.length>0" v-for="(value,index) in cartList" :key="index"
        :class="'c-section'+(index+1)">
        <div class="header">
          <img class="select" :src="value.isSel===1?msgImg_s:msgImg_n" @click="companyClick(index)">
          <div class="title">{{value.company_name}}</div>
          <div class="call" @click="serverClick"></div>
          <!--          <a :href="'tencent://message/?uin=' + value.qq + '&site=qq&menu=yes'"><div class="call" v-show="value.qq !== '-1'"></div></a>-->
        </div>
        <SwipeCell class="c-row" :border="false" v-for="(item,i) in value.list" :key="i">
          <div class="no-valid" v-show="item.tails.isValid===0">失效</div>
          <img class="select" v-show="item.tails.isValid===1" :src="item.isSel===1?msgImg_s:msgImg_n"
            @click="goodsClick(index,i)">
          <div class="imgbox">
            <img class="pic" :src="item.product_cover" @click="goGoodsClick(index,i)" />
          </div>
          <div class="title" @click="goGoodsClick(index,i)">{{item.product_name}}</div>
          <div v-show="item.tails.isValid===1">
            <div class="spec" @click="specClick(index,i)">
              <div class="spec-info">{{item.spec+'；'+item.color}}</div>
              <div class="down"></div>
            </div>
            <div class="price">￥{{utils.keepPoint(item.unit_price/100)}}</div>
            <div class="reduce" :class="{ defaultNumber:item.isReduce===0, activeNumber:item.isReduce===1}"
              @click="reduceClick(index,i)">
              <div class="img">-</div>
            </div>
            <input class="number" v-model="item.number" @focus="numberFocus(index,i)" @blur="numberBlur(index,i)"
              oninput="if(value.length == 1){value=value.replace(/[^1-9]/g,'')}else{value=value.replace(/[^0-9]/g,'')}"
              onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}" />
            <div class="add" :class="{ defaultNumber:item.isAdd===0, activeNumber:item.isAdd===1}"
              @click="addClick(index,i)">
              <div class="img">+</div>
            </div>
          </div>
          <div class="no-tip" v-show="item.tails.isValid===0">宝贝已不能购买</div>
          <template #right>
            <!-- <van-button class="rightItem" type="primary" size="normal" @click="collectionClick(index,i)">加入<br />收藏夹
            </van-button> -->
            <van-button class="rightItem" type="default" size="normal" @click="removeClick(index,i)">
              删除<br />&nbsp;&nbsp;</van-button>
          </template>
        </SwipeCell>
      </div>
    </div>
    <cartBottom v-show="cartList.length>0" :state="bottomState" :isAll="isSelAll" :price="allPrice"
      @click="cartBottomClick"></cartBottom>
    <goodsSelect :show="showGoodsSelect" type="0" :goodsInfo="goodsInfo" :cartInfo="oldCartInfo" @click="selGoodsClick"
      @hideClick="hideSelClick"></goodsSelect>

  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { SwipeCell } from 'vant'
import mainHeader from '@/view/header'
import cartBottom from '../shoppingCart/cart-bottom'
import goodsSelect from '../goods/goods-select'
// import wxPay from '@/wx/weixin'
// import videoView from '@/components/video-view'
// import AlertView from '@/components/alert-view'
export default {
  name: 'shopping-cart',
  inject: ['reload'], // 界面刷新
  data () {
    return {
      isLogin: 0,
      bottomState: 0,
      isSelAll: 0,
      viewHeight: '0px',
      allPrice: this.utils.keepPoint(0),
      showGoodsSelect: false,
      msgImg_n: require('../../../assets/radio_n.png'),
      msgImg_s: require('../../../assets/radio_s.png'),
      cartList: [], // 购物车列表数据
      goodsArray: [], // 选中的商品数据
      goodsInfoId: 0, // 当前的商品信息id
      goodsInfo: {}, // 当前更新的商品信息
      cSection: 0, // 当前更新头 index
      cRow: 0, // 当前更新头 index
      headerFixed: '',
      oldCartInfo: {}, // 更改之前的单条购物车信息,
      showHeader: true
    }
  },
  methods: {
    logoutClick: function () { // 退出登录  刷新界面
      this.reload()
    },
    serverClick () {
      this.YSF.init('1a5d46871ba2e8c628b5a7abe265ef26', {
        templateId: 123, // templateId表示自定义会话邀请的模板标识
        shuntId: 123, // shuntId表示访客选择多入口分流模版id
        sessionInvite: false, // sessionInvite表示是否开启会话邀请设置
        hidden: 1 // hidden表示是否隐藏访客端默认入口
      }).then(ysf => {
        ysf('open')
      }).catch(error => {
        console.log(error)
        console.log('sdk加载失败')
      })
      // window.location.href = 'tel:4001919119'
      // if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      //   if (this.utils.isIphone()) {
      //     window.webkit.messageHandlers.callService.postMessage('4001919119')
      //   } else {
      //     window.zxzx.callService('4001919119')
      //   }
      // } else {
      //   window.location.href = 'tel:4001919119'
      // }
    },
    goGoodsClick: function (i, j) {
      console.log('===========')
      let info = this.cartList[i].list[j]
      this.$router.push({ path: '/goodsdetail', query: { goodsId: info.goods_id, businessId: info.supplier_id } })
    },
    companyClick: function (i) {
      console.log('companyClick===========')
      if (this.cartList[i].isSel === 0) {
        this.cartList[i].isSel = 1
        for (let j = 0; j < this.cartList[i].list.length; j++) {
          this.cartList[i].list[j].isSel = 1
        }
      } else {
        this.cartList[i].isSel = 0
        for (let j = 0; j < this.cartList[i].list.length; j++) {
          this.cartList[i].list[j].isSel = 0
        }
      }
      this.getGoodsList()
    },
    goodsClick: function (i, j) {
      console.log('goodsClick===========')
      if (this.cartList[i].list[j].isSel === 0) {
        this.cartList[i].list[j].isSel = 1
      } else {
        this.cartList[i].list[j].isSel = 0
      }
      var count = 0
      for (let j = 0; j < this.cartList[i].list.length; j++) {
        if (this.cartList[i].list[j].isSel === 1) {
          count += 1
        }
      }
      if (count === this.cartList[i].list.length) {
        this.cartList[i].isSel = 1
      } else {
        this.cartList[i].isSel = 0
      }
      this.getGoodsList()
    },
    reduceClick: function (i, j) {
      this.loadGoodsInfo(i, j, 0)
      let cInfo = JSON.stringify(this.cartList[i].list[j])
      this.oldCartInfo = JSON.parse(cInfo)
      this.cSection = i
      this.cRow = j

      let number = this.cartList[i].list[j].number

      if (number - 1 < this.cartList[i].list[j].tails.min_order_num) {
        Toast('该商品' + this.cartList[i].list[j].tails.min_order_num + '件起购')
        this.cartList[i].list[j].number = this.cartList[i].list[j].tails.min_order_num
        return false
      }

      if (number > 1) {
        this.cartList[i].list[j].number -= 1
      }
      this.setState(i, j)
    },
    addClick: function (i, j) {
      this.loadGoodsInfo(i, j, 0)

      let cInfo = JSON.stringify(this.cartList[i].list[j])
      this.oldCartInfo = JSON.parse(cInfo)
      this.cSection = i
      this.cRow = j

      let number = this.cartList[i].list[j].number
      if (number + 1 < this.cartList[i].list[j].tails.min_order_num) {
        Toast('该商品' + this.cartList[i].list[j].tails.min_order_num + '件起购')
        this.cartList[i].list[j].number = this.cartList[i].list[j].tails.min_order_num
        return false
      }

      if (number < 999999) {
        this.cartList[i].list[j].number += 1
      }
      this.setState(i, j)
    },
    numberFocus: function (i, j) {
      this.loadGoodsInfo(i, j, 0)
    },
    numberBlur: function (i, j) {
      console.log('numberBlur:', i, j, this.cartList)
      let number = this.cartList[i].list[j].number
      if (number - 1 < this.cartList[i].list[j].tails.min_order_num) {
        Toast('该商品' + this.cartList[i].list[j].tails.min_order_num + '件起购')
        this.cartList[i].list[j].number = this.cartList[i].list[j].tails.min_order_num
      }

      this.loadGoodsInfo(i, j, 0)

      let cInfo = JSON.stringify(this.cartList[i].list[j])
      this.oldCartInfo = JSON.parse(cInfo)
      this.cSection = i
      this.cRow = j

      this.setState(i, j)
    },
    setState: function (i, j) { // 0 添加 1 减 2更新规格
      let number = this.cartList[i].list[j].number
      if (number <= 0) {
        this.cartList[i].list[j].number = 1
      }
      this.cartList[i].list[j].count = this.cartList[i].list[j].number * parseInt(this.cartList[i].list[j].unit_price)
      if (number > 1) {
        this.cartList[i].list[j].isReduce = 1
      } else {
        this.cartList[i].list[j].isReduce = 0
      }
      if (number < 10000000) {
        this.cartList[i].list[j].isAdd = 1
      } else {
        this.cartList[i].list[j].isAdd = 0
      }
      this.getGoodsList()
      this.updateCart(i, j)
    },
    updateCart: function (i, j) { // 更新购物车数据 + - 修改规格
      var _this = this
      let info = this.cartList[i].list[j]
      this.utils.post(this.companyUrl + '/shoppingCart/update', info, function (response) {
        if (response.code === 1) {
          _this.resetCartInfo()
        } else {
          // _this.loadData()
        }
      })
    },
    resetCartInfo: function () {
      console.log('999999===============')
      console.log(this.oldCartInfo)
      this.cartList[this.cSection].list[this.cRow] = this.oldCartInfo
      this.cartList[this.cSection].list[this.cRow].isAdd = 0
      this.cartList[this.cSection].list[this.cRow].number = this.maxNumberSpec(this.oldCartInfo.spec_detail)
      this.$set(this.cartList[this.cSection].list, this.cRow, this.cartList[this.cSection].list[this.cRow])
      this.getGoodsList()
      console.log(this.cartList)
    },
    maxNumberSpec: function (specColor) { // 获取以商品当前规格的最大库存
      for (let i = 0; i < this.goodsInfo.detailList.length; i++) {
        let info = this.goodsInfo.detailList[i]
        if (info.spec_detail.indexOf(specColor) >= 0) {
          return info.inventory
        }
      }
      return 0
    },
    collectionClick: function (i, j) { // 收藏商品
      let info = this.cartList[i].list[j]
      this.utils.post(this.companyUrl + '/goods/collect?goods_ids=' + info.goods_id, null, function (response) {
        Toast('收藏产品成功')
      })
    },
    removeClick: function (i, j) { // 删除商品
      var _this = this
      let info = this.cartList[i].list[j]
      let param = {
        ids: info.id
      }
      this.utils.post(this.companyUrl + '/shoppingCart/remove', param, function (response) {
        Toast('删除成功')
        if (_this.cartList[i].list.length === 1) {
          _this.cartList.splice(i, 1)
          if (_this.cartList.length <= 0) {
            _this.setViewHeight(0)
          }
        } else {
          _this.cartList[i].list.splice(j, 1)
        }
        _this.getGoodsList()
      })
    },
    specClick: function (i, j) {
      this.cSection = i
      this.cRow = j
      this.loadGoodsInfo(i, j, 1)
    },
    loadGoodsInfo: function (i, j, isSpec) {
      let info = this.cartList[i].list[j]
      // 已经有 访问商品详情信息
      if (this.goodsInfoId === info.goods_id) {
        if (isSpec === 1) {
          this.showGoodsSelect = true
        }
        return
      }

      var _this = this
      // 商品信息
      let urlPath = this.accountUrl + '/goods/goodsDetail?goods_id=' + info.goods_id + '&userId=' + info.user_id
      this.utils.GET(urlPath, function (response) {
        // var result = response.data
        _this.goodsInfoId = response.data.goods.id
        _this.goodsInfo = response.data.goods
        if (isSpec === 1) {
          _this.showGoodsSelect = true
        }
      })
    },
    selGoodsClick: function (type, index, selectedNum) { // 0 修改规格
      console.log('type------修改规格' + this.cSection + '--' + this.cRow)
      let info = this.goodsInfo.detailList[index]
      console.log(info)
      let spec = JSON.parse(info.spec_detail)
      // 价格
      if (info.discount_price === undefined) {
        info.discount_price = info.original_price
      }
      let count = parseInt(info.discount_price) * selectedNum

      this.cartList[this.cSection].list[this.cRow].number = selectedNum
      this.cartList[this.cSection].list[this.cRow].count = count
      this.cartList[this.cSection].list[this.cRow].original_price = info.original_price
      this.cartList[this.cSection].list[this.cRow].unit_price = info.discount_price
      this.cartList[this.cSection].list[this.cRow].color = '颜色：' + spec['颜色']
      this.cartList[this.cSection].list[this.cRow].spec = '规格：' + spec['规格']
      this.cartList[this.cSection].list[this.cRow].spec_detail = info.spec_detail

      console.log('=============1111111111111')
      this.updateCart(this.cSection, this.cRow)
    },
    hideSelClick: function () {
      this.showGoodsSelect = false
    },
    loadData: function (info) {
      console.log('购物车-------------------------')
      var _this = this
      // 购物车列表
      let urlPath = this.companyUrl + '/shoppingCart/list?page=1&rows=999&type=2&order=1'
      // let urlPath = 'http://www.zxzx119.com/account/goods/goodsDetail?goods_id=' + '9409' + '&userId=0'
      console.log('购物车：' + urlPath)

      this.utils.GET(urlPath, function (response) {
        var result = response.data.rows
        var cHeight = 50 * result.length
        for (let i = 0; i < result.length; i++) {
          result[i].isSel = 0
          cHeight += (140 * result[i].list.length)
          for (let j = 0; j < result[i].list.length; j++) {
            if (result[i].list[j].product_cover.indexOf(',') >= 0) {
              result[i].list[j].product_cover = result[i].list[j].product_cover.split(',')[0]
            }
            let spec = JSON.parse(result[i].list[j].spec_detail)
            result[i].list[j].spec = '规格：' + spec['规格']
            result[i].list[j].color = '颜色：' + spec['颜色']
            if (_this.cartList && _this.cartList.length > 0) {
              result[i].list[j].isSel = _this.cartList[i].list[j].isSel
              result[i].isSel = _this.cartList[i].isSel
            } else {
              result[i].list[j].isSel = 0
            }

            result[i].list[j].isAdd = 1
            if (result[i].list[j].number <= 1) {
              result[i].list[j].isReduce = 0
            } else {
              result[i].list[j].isReduce = 1
            }
          }
        }
        _this.cartList = result
        _this.setViewHeight(cHeight)
        console.log(_this.cartList)
      })
    },
    isAllSelect: function (isAll) {
      for (let i = 0; i < this.cartList.length; i++) {
        this.cartList[i].isSel = isAll
        for (let j = 0; j < this.cartList[i].list.length; j++) {
          this.cartList[i].list[j].isSel = isAll
        }
      }
      this.getGoodsList()
    },
    getGoodsList: function () {
      this.goodsArray = []
      this.allPrice = 0
      this.isSelAll = 1
      for (let i = 0; i < this.cartList.length; i++) {
        for (let j = 0; j < this.cartList[i].list.length; j++) {
          if (this.cartList[i].list[j].isSel === 1 && this.cartList[i].list[j].tails.isValid === 1) {
            this.allPrice += (this.cartList[i].list[j].unit_price * this.cartList[i].list[j].number)
            this.goodsArray.push(this.cartList[i].list[j])
          } else {
            if (this.cartList[i].list[j].isSel === 0 && this.cartList[i].list[j].tails.isValid === 1) {
              this.isSelAll = 0
            }
          }
        }
      }
      this.allPrice = this.utils.keepPoint(this.allPrice / 100)
      if (this.goodsArray.length <= 0) {
        this.bottomState = 0
      } else {
        this.bottomState = 1
      }
    },
    cartBottomClick: function (type) {
      // 0 取消全选 1 全选 2 点击结算
      if (type === 0 || type === 1) {
        this.isAllSelect(type)
        return
      }
      if (type === 2) { // 结算
        this.getGoodsList()
        this.goTobuy()
      }
    },
    goTobuy: function () {
      if (this.goodsArray.length <= 0) {
        console.log(123123)
        Toast('您还没有选择宝贝哦')
        return
      }
      let supplierList = []
      this.goodsArray.forEach(item => {
        if (supplierList.indexOf(item.supplier_id) < 0) {
          supplierList.push(item.supplier_id)
        }
      })
      if (supplierList.length > 1) {
        Toast('您只能购买同一店铺下的商品！')
        return
      }
      var _this = this
      this.utils.post(this.companyUrl + '/zxOrder/settlementData', this.goodsArray, function (response) {
        let orderDetail = response.data
        orderDetail.forEach((val, index) => {
          orderDetail[index]['isNewMallOrder'] = false// 是否生成订单
        })
        var jsonStr = JSON.stringify(orderDetail)
        // d.setHours(d.getHours() + (1)) // 保存一个小时
        // document.cookie = 'goodsJson=' + jsonStr + ';path=/;expires=' + d.toGMTString()
        _this.$store.commit('setCommodity', jsonStr)
        _this.$store.commit('clearOrderId', '')
        _this.$router.push({ path: '/checkOrder' })
      })
    },
    goToGoods: function () {
      localStorage.setItem('tab', 0)
      this.$router.replace({ path: '/homePage/goodslist' })
    },
    setViewHeight: function (height) {
      let winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      if (height <= 0) {
        this.viewHeight = winHeight + 'px'
      } else {
        let cheight = 15 + this.cartList.length * 15 + height
        console.log('height---' + winHeight + '---' + cheight)
        var conHeight = 55 + 65
        if (parseInt(this.$route.query.isTab) === 1) {
          conHeight = conHeight + 50
        }
        if (cheight < (winHeight - conHeight)) {
          this.viewHeight = winHeight + 'px'
        } else {
          this.viewHeight = (winHeight - conHeight) + 'px'
        }
      }
      console.log('this.viewHeight--' + this.viewHeight)
    }
  },
  components: {
    mainHeader,
    SwipeCell,
    cartBottom,
    goodsSelect
  },
  beforeRouteEnter (to, from, next) {
    if (from.name === '/home') {
      localStorage.setItem('fromHome', true)
    }
    next(vm => {
      localStorage.setItem('tab', 1)
    })
  },
  beforeRouteLeave (to, from, next) {
    if (from.name === '/home') {
      localStorage.setItem('fromHome', true)
    }
    next()
  },
  created () {
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      this.showHeader = false
    } else {
      this.showHeader = true
    }
  },
  mounted () {
    var _this = this
    this.utils.isUserLogin(function (login) {
      if (login === 1) {
        _this.isLogin = 1
        _this.loadData()
      } else {
        _this.isLogin = 0
        Toast('您还未登录，请先登录后查看购物车！')
        _this.$router.push({ path: 'login', query: { back: 1 } })
      }
    })
    document.body.scrollTop = document.documentElement.scrollTop = 0
  }
}
</script>

<style scoped>
#shopping-cart{
 height: 100vh;
}
.wrapper {
  position: relative;
  background-color: #f6f6f6;
  /*padding-top: 15px;*/
  /*margin-top: 10px;*/
  overflow-y: scroll;
}
.c-section {
  position: relative;
  background-color: #ffffff;
  min-height: 190px;
  margin: 0px 15px 15px 15px;
  border-radius: 4px;
}
.c-section1 {
  border-top: solid 15px #f6f6f6;
  box-sizing: border-box;
}
.c-section .header {
  position: relative;
  height: 50px;
}
.c-section .header .select {
  position: absolute;
  left: 10px;
  top: 15px;
  height: 20px;
  width: 20px;
}
.c-section .header .title {
  position: absolute;
  left: 40px;
  top: 15px;
  height: 20px;
  line-height: 20px;
  right: 110px;
  font-size: 14px;
  font-weight: bold;
  color: #0e050a;
}
.c-section .header .call {
  position: absolute;
  right: 10px;
  top: 15px;
  height: 20px;
  width: 66px;
  background-image: url("../images/icon-contract.png");
  background-size: cover;
}
.c-row {
  position: relative;
  height: 140px;
  width: 100%;
}
.c-row .no-valid {
  position: absolute;
  left: 5px;
  top: 40px;
  height: 20px;
  line-height: 20px;
  width: 30px;
  background-color: #808080;
  border-radius: 9px;
  color: #ffffff;
  font-size: 11px;
  text-align: center;
}
.c-row .no-tip {
  position: relative;
  left: 145px;
  top: 50px;
  height: 20px;
  line-height: 20px;
  color: #cccccc;
  font-size: 12px;
  /*background-color: yellow;*/
}
.c-row .select {
  position: absolute;
  left: 10px;
  top: 40px;
  height: 20px;
  width: 20px;
}
.c-row .imgbox {
  position: absolute;
  left: 40px;
  top: 5px;
  height: 90px;
  width: 90px;
  background-color: #ffffff;
  border: solid 1px #e5e5e5;
  box-sizing: content-box;
}
.c-row .imgbox .pic {
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.c-row .title {
  position: relative;
  left: 145px;
  top: 5px;
  min-height: 20px;
  max-height: 40px;
  line-height: 20px;
  width: calc(100% - 155px);
  font-size: 13px;
  color: #0e050a;
  /*background-color: yellow;*/
  overflow: hidden;
  /*white-space: nowrap;*/
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.c-row .spec {
  position: relative;
  left: 145px;
  top: 10px;
  min-height: 24px;
  line-height: 20px;
  max-height: 44px;
  width: calc(100% - 155px);
  font-size: 12px;
  color: #808080;
  background-color: #eeeeee;
  border-radius: 2px;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.c-row .spec .spec-info {
  position: relative;
  margin-right: 30px;
  padding: 2px 8px;
  line-height: 20px;
  /*background-color: #bbd2ff;*/
}
.c-row .spec .down {
  position: absolute;
  top: 12px;
  right: 10px;
  width: 7px;
  height: 4px;
  background-image: url("../images/icon-down.png");
  background-size: cover;
}
.c-row .price {
  position: absolute;
  left: 145px;
  top: 105px;
  height: 22px;
  line-height: 22px;
  right: 120px;
  font-size: 12px;
  color: #c41335;
}
.c-row .add {
  position: absolute;
  right: 10px;
  top: 105px;
  height: 22px;
  line-height: 22px;
  width: 22px;
  font-size: 20px;
  text-align: center;
  border-radius: 2px;
  box-sizing: content-box;
}
.c-row .number {
  position: absolute;
  right: 37px;
  top: 105px;
  height: 22px;
  line-height: 22px;
  width: 40px;
  font-size: 12px;
  color: #333333;
  border-radius: 2px;
  text-align: center;
  border: solid 1px #cccccc;
  box-sizing: content-box;
}
.c-row .reduce {
  position: absolute;
  right: 82px;
  top: 105px;
  height: 22px;
  line-height: 22px;
  width: 22px;
  font-size: 20px;
  text-align: center;
  border-radius: 2px;
  box-sizing: content-box;
}
.c-row .add .img,
.c-row .reduce .img {
  position: absolute;
  left: 0px;
  top: 3px;
  width: 22px;
  height: 14px;
  line-height: 14px;
}
.defaultNumber {
  color: #bebebe;
  background-color: #ffffff;
  border: solid 1px #eeeeee;
}
.activeNumber {
  color: #808080;
  background-color: #eeeeee;
  border: solid 1px #cccccc;
}
.empty-row {
  position: relative;
  background-color: #ffffff;
  width: 100%;
  height: 230px;
}
.empty-row .image {
  position: absolute;
  top: 100px;
  left: calc(50% - 15px);
  width: 29px;
  height: 45px;
  background-image: url("../images/icon-cart-empty.png");
  background-size: cover;
}
.empty-row .tip {
  position: absolute;
  top: 150px;
  left: 0px;
  right: 0px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 15px;
  color: #999999;
}
.empty-row .buy {
  position: absolute;
  left: calc(50% - 40px);
  top: 200px;
  width: 80px;
  height: 30px;
  line-height: 30px;
  border-radius: 4px;
  background-color: #c41335;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
}
>>> .van-swipe-cell__right {
  background-color: #c41335;
  height: 140px;
  right: -1px;
}
>>> .rightItem,
.van-button,
.van-button--danger,
.van-button--normal,
.van-button--square {
  height: 140px;
  line-height: 20px;
  color: #ffffff;
}
>>> .van-button--primary {
  background-color: #730609;
  border: 1px solid #730609;
  box-sizing: content-box;
}
>>> .van-button--default {
  background-color: #c41335;
  border: 1px solid #c41335;
  box-sizing: content-box;
}
.sectionHeader {
  height: 55px;
  width: 100%;
  z-index: 900;
}
.sectionHeader .isFixed {
  position: fixed;
  top: 0px;
  height: 55px;
  width: 100%;
  z-index: 900;
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/shoppingCart/index.vue